import { ContentTypeFilterClause, ExplorableItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { NavLocationSelectors } from '../../../app/selectors/NavigationStateSelectors';
import { getAppStore } from '../../../app/AppStore';
import { SessionSiteSelectors } from '../../../app/selectors/SessionInfoSelectors';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { Schedules } from '../../resources/Schedules';

export const ScheduleDefinition: ExplorableItemDefinition & SpaceDefinition<'schedule'> = {
  itemType: 'schedule',
  contentType: 'schedule',
  singularName: Messages.schedule,
  pluralName: Messages.schedules,
  emptyStateMessage: Messages.schedulesEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: (_projectId: string) => {
    // if on site schedules page return a siteId filter
    const inServerArea = NavLocationSelectors.inServerArea(getAppStore().getState());
    if (!inServerArea) {
      const siteId: string = SessionSiteSelectors.siteId(getAppStore().getState());
      return {siteId: ServerFilterClauses.serverFilterClauses.siteId(siteId)};
    }
    return undefined;
  },
  cardComponent: GenericCard,
  listViewIconUrl: null,
  headerIconPath: () => imgPath('spaces_masthead_schedule.svg'),
  filterClause: ServerFilterClauses.ContentType(['schedule']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    const schedulesResource = ServiceLocator.get<Schedules>('Schedules');
    return schedulesResource.all();
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: () => '',
  supportedDisplayModes: ['list'],
};
